<template>
    <async-wrapper :data="courier" :loading="async.loading" :error="async.error">
        <template slot="dataComponent">
            <div v-if="courier" class="row">
                <div class="col-xl-12">
                    <div class="card">
                        <div class="card-header mb-3">
                            <h5 class="mb-1 mt-3">{{ courier[COURIERS.fields.name] }}</h5>
                            <p class="hint mt-0">{{ courier.id }}</p>
                            <badge :type="courier[COURIERS.fields.visibility] === VISIBILITY_STATUS.VISIBLE ? 'success' : 'danger'">
                                {{ courier[COURIERS.fields.visibility] === VISIBILITY_STATUS.VISIBLE ? 'Visible' : 'Hidden' }}
                            </badge>
                        </div>
                        <div class="card-body d-flex flex-column">
                            <div class="row mb-3">
                                <div class="col-xl-12">
                                    <p class="card-category mb-2">Internal Contact</p>
                                </div>
                                <div class="col-xl-6">
                                    <p class="hint mb-0">Email</p>
                                    <h6>{{ courier[COURIERS.fields.internalContact][COURIERS.internalContact.email] }}</h6>
                                </div>
                                <div class="col-xl-6">
                                    <p class="hint mb-0">Phone Number</p>
                                    <h6>
                                        <phone-number :value="courier[COURIERS.fields.internalContact][COURIERS.internalContact.phoneNumber]"></phone-number>
                                    </h6>
                                </div>
                                <div v-if="courier[COURIERS.fields.externalContact]" class="col-xl-12 my-2"></div>
                                <div v-if="courier[COURIERS.fields.externalContact]" class="col-xl-12">
                                    <p class="card-category mb-2">External Contact</p>
                                </div>
                                <div v-if="courier[COURIERS.fields.externalContact]" class="col-xl-6">
                                    <p class="hint mb-0">Email</p>
                                    <h6>{{ courier[COURIERS.fields.externalContact][COURIERS.externalContact.email] || 'N/A' }}</h6>
                                </div>
                                <div v-if="courier[COURIERS.fields.externalContact]" class="col-xl-6">
                                    <p class="hint mb-0">Phone Number</p>
                                    <h6>
                                        <phone-number :value="courier[COURIERS.fields.externalContact][COURIERS.externalContact.phoneNumber]"> </phone-number>
                                    </h6>
                                </div>
                                <div class="col-xl-12 my-3"></div>
                                <div class="col-xl-6">
                                    <p class="hint mb-0">Route Rules Type</p>
                                    <h6>{{ courier[COURIERS.fields.routeRulesType] }}</h6>
                                </div>
                                <div class="col-xl-6">
                                    <p class="hint mb-0">Order Status</p>
                                    <h6>{{ courier[COURIERS.fields.orderStatus] }}</h6>
                                </div>
                            </div>
                            <div class="row mb-3 flex-grow">
                                <div class="col-xl-12">
                                    <p class="hint mb-1">Details</p>
                                    <p>{{ courier[COURIERS.fields.detail] || 'N/A' }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template slot="loadingComponent">
            <i class="fa fa-circle-o-notch fa-2x fa-spin mt-5"></i>
        </template>
        <template slot="errorComponent">
            <p>{{ async.error }}</p>
        </template>
    </async-wrapper>
</template>
<script>
import AsyncWrapper from 'Shared/Wrappers/AsyncWrapper'
import { COURIERS } from 'db'
import { Badge } from '@/components/UIComponents'
import { VISIBILITY_STATUS } from '@/utils/constants'
export default {
    components: {
        AsyncWrapper,
        Badge
    },
    props: {
        courierId: {
            type: [String, Boolean],
            required: true
        }
    },
    data() {
        return {
            COURIERS,
            VISIBILITY_STATUS
        }
    },
    computed: {
        async() {
            return this.$store.getters['couriers/GET_ASYNC']
        },
        courier() {
            return this.$store.getters['couriers/GET_COURIER']
        }
    },
    created() {
        this.$store.dispatch('couriers/FETCH_COURIER_BY_ID', {
            id: this.courierId
        })
    },
    beforeDestroy() {
        this.$store.dispatch('couriers/REMOVE_COURIER_REFERENCE', {
            id: this.courierId
        })
    }
}
</script>

<style lang="scss" scoped>
.card {
    img.logo-image {
        position: relative;
        max-width: 64px;
        max-height: 64px;
    }
}
.p-badge {
    margin-right: 0.25rem;
}
</style>
